// drawGrid.js

/**
 * drawGrid – draws a simple coordinate grid; optionally draws the axes.
 *
 * @param {HTMLCanvasElement} canvas
 * @param {Object} options
 *   - widthCells, heightCells, cellSize
 *   - showAxes (boolean) whether to draw the black x/y axes at 0
 * @param {Array} points to plot
 */
export default function drawGrid(
  canvas,
  { widthCells = 10, heightCells = 10, cellSize = 20, showAxes = true } = {},
  points = []
) {
  if (!canvas) return;
  const ctx = canvas.getContext("2d");
  const W = widthCells * cellSize,
        H = heightCells * cellSize;

  // clear everything
  ctx.clearRect(0, 0, W, H);

  // light grid lines
  ctx.strokeStyle = "#eee";
  for (let i = 0; i <= widthCells; i++) {
    const x = i * cellSize;
    ctx.beginPath();
    ctx.moveTo(x, 0);
    ctx.lineTo(x, H);
    ctx.stroke();
  }
  for (let j = 0; j <= heightCells; j++) {
    const y = j * cellSize;
    ctx.beginPath();
    ctx.moveTo(0, y);
    ctx.lineTo(W, y);
    ctx.stroke();
  }

  // optional axes
  if (showAxes) {
    ctx.strokeStyle = "#444";
    ctx.lineWidth = 1.5;
    ctx.beginPath();
    // y axis
    ctx.moveTo(0, H/2);
    ctx.lineTo(W, H/2);
    // x axis
    ctx.moveTo(W/2, 0);
    ctx.lineTo(W/2, H);
    ctx.stroke();
  }

  // plot any red points + labels
  points.forEach(({ x, y }) => {
    const cx = (x + widthCells/2) * cellSize;
    const cy = (heightCells/2 - y) * cellSize;
    ctx.beginPath();
    ctx.arc(cx, cy, 4, 0, 2*Math.PI);
    ctx.fillStyle = "red";
    ctx.fill();
    ctx.font = "12px sans-serif";
    ctx.fillText(`(${x},${y})`, cx + 6, cy - 6);
  });
}
